import React from 'react';
import './VideoLinkPageTemplate.css';

function VideoLinkPageTemplate({ title, subtitle, description, videoSrc, imageSrc }) {
  return (
    <div className="project-page-template">
      <div className="project-page-media">
        {/* Conditionally render either video or image */}
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={title}
            className="project-page-media-frame"
          />
        ) : (
          <iframe
            width="900"
            height="506"
            src={videoSrc}
            title={title}
            frameBorder="0"
            allowFullScreen
            className="project-page-media-frame"
          ></iframe>
        )}
      </div>

      <div className="project-page-copy">
        <h2>{title}</h2>
        {subtitle && (
          <h4 className="project-page-subtitle">
            {subtitle}
          </h4>
        )}
        <p>{description}</p>
      </div>

    </div>
  );
}

export default VideoLinkPageTemplate;
